var map = {
	"./aws.png": 6603,
	"./azure.png": 2874,
	"./beaver400x400.png": 5002,
	"./fox400x400.png": 2466,
	"./openapi.png": 5214,
	"./sql-server.png": 9733,
	"./sql.png": 9891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5675;